import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import NavigationNodes from '@nexus/fff-ui-shared/NavigationNodes';
import ProgressBar from '@nexus/fff-ui-shared/ProgressBar';

import styles from './PageProgress.module.scss';

const PageProgress = ({ list, currentNode, maxPages, currentPage }) => (
  <div className={styles.pageProgress} data-testid="page-progress">
    <PageContainer className={styles.pageContainer}>
      <NavigationNodes list={list} currentStep={currentNode}></NavigationNodes>
      <ProgressBar maxPages={maxPages} currentPage={currentPage}></ProgressBar>
      <h2>Boost Your Box</h2>
    </PageContainer>
    <hr />
  </div>
);

PageProgress.propTypes = {
  list: PropTypes.array,
  currentNode: PropTypes.number,
  maxPages: PropTypes.number,
  currentPage: PropTypes.number,
};

PageProgress.defaultProps = {
  list: ['Customize', 'Boost Your Box', 'Add-Ons'],
  currentNode: 1,
  maxPages: 2,
  currentPage: 1,
};

export default PageProgress;
